/** @format */

import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import SetClientDefault from './SetClientDefault';

export interface ClientSubscrActivateSubscrRequest {
    IMSI: string;
    TARIFF_PLAN_NAME: string;
    EXTERNAL_ID: string;
    SUBSCRIPTION_NAME: string;
}

export default class ClientSubscrActivateSubscr extends SetClientDefault {
    constructor(operation: MvnoOperation) {
        super(operation);
        let l = 1;
    }
}
